import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "../actions/orderActions";
import AdminOrderListRow from "../components/adminOrder/AdminOrderListRow";
import { NavLink } from "react-router-dom";
import { paginationDataToShow } from "../actions/generalActions";

const AdminOrderPage = () => {
  const categories = useSelector((state) => state.categories);
  const subCategories = useSelector((state) => state.subCategories);
  const store = useSelector((state) => state.store);
  const orders = useSelector((state) => state.orders);
  const auth = useSelector((state) => state.auth);
  const items = useSelector((state) => state.items);
  const dispatch = useDispatch();

  const orderData = async (e) => {
    // dispatch(getAllVehicle({companyId: auth.user.companyId.id, limit: limit, page: currentPageNumber }))
    dispatch(
      getAllOrders({
        ...(auth?.user?.role === "admin" && { storeId: auth?.user?.storeId }),
        // categoriesId: auth?.user?.companyId?.id,
        // limit: limit,
        // page: currentPageNumber,
      })
    );
  };
  useEffect(() => {
    orderData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("orderNo");
  const [sortOrder, setSortOrder] = useState("desc"); //asc, desc
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(25); // Set your default limit here

  // Function to handle pagination, sorting, and searching
  const handlePagination = (page, field, order, search, newLimit) => {
    let newPage;
    if (page < 1) {
      newPage = 1;
    } else if (page > paginatedData.totalPages) {
      newPage = paginatedData.totalPages;
    } else {
      newPage = page;
    }
    setCurrentPage(newPage);
    setSortField(field);
    setSortOrder(order);
    setSearchTerm(search);
    setLimit(newLimit);
  };

  const fullData = orders?.orders;
  // Use the pagination function to get the data for the current page
  const paginatedData = paginationDataToShow(
    limit,
    currentPage,
    fullData,
    sortField,
    sortOrder,
    searchTerm
  );
  // Function to handle sorting icon click
  const handleSortClick = (field, order) => {
    // Call handlePagination with sorting parameters
    handlePagination(currentPage, field, order, searchTerm, limit);
  };
  // Function to determine the color based on the current sorting order
  const getArrowColor = (field, direction) => {
    return sortField === field && sortOrder === direction
      ? "#000000"
      : "#A0A0A0";
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Orders</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                          <button className="btn btn-warning">
                            Bulk CSV Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mx-2 my-2">
                      <div className="col">
                        <form action="">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search User"
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-dark">Search</button>
                          <button className="btn btn-primary">Clear</button>
                        </div>
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>Username</th>
                            {auth?.user?.role === "superAdmin" && (
                              <th>Store</th>
                            )}
                            <th>Date</th>
                            <th>Total</th>
                            <th>Order To</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders &&
                            orders?.orders &&
                            orders?.orders?.length > 0 &&
                            // orders?.orders?.map((current, i) => {
                            paginatedData?.results.map((current, i) => {
                              if (current.delete === false) {
                                return (
                                  <AdminOrderListRow
                                    current={current}
                                    i={i}
                                    key={i}
                                    // handleModal={handleModal}
                                  />
                                );
                              }
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">
                        Showing{" "}
                        {1 +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        to{" "}
                        {paginatedData?.displayingResults +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        of {paginatedData?.totalResults} entries
                      </p>

                      <nav aria-label="...">
                        <ul className="pagination">
                          {/* Previous Button */}
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <NavLink
                              className="page-link"
                              href="#"
                              tabIndex="-1"
                              aria-label="Previous"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage > 1) {
                                  handlePagination(
                                    currentPage - 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Previous
                            </NavLink>
                          </li>

                          {/* Dynamic Pagination Buttons */}
                          {paginatedData?.paginationArr?.length > 0 &&
                            Array.from(
                              {
                                length:
                                  paginatedData.endPage -
                                  paginatedData.startPage +
                                  1,
                              },
                              (_, i) => {
                                const current = paginatedData?.startPage + i;
                                return paginatedData?.currentPageNumber ===
                                  current ? (
                                  <li className="page-item active" key={i}>
                                    <a className="page-link" href="#">
                                      {current}{" "}
                                      <span className="sr-only">(current)</span>
                                    </a>
                                  </li>
                                ) : (
                                  <li className="page-item" key={i}>
                                    <NavLink
                                      className="page-link"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handlePagination(
                                          parseInt(current),
                                          sortField,
                                          sortOrder,
                                          searchTerm,
                                          limit
                                        );
                                      }}
                                    >
                                      {current}
                                    </NavLink>
                                  </li>
                                );
                              }
                            )}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              currentPage === paginatedData?.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <a
                              className="page-link"
                              href="#"
                              aria-label="Next"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage < paginatedData?.totalPages) {
                                  handlePagination(
                                    currentPage + 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminOrderPage;
